<template>
  <div>
    <b-card v-if="cardCreatedPage" no-body>
      <div class="p-3 modalDiv">
        <b-row cols="2">
          <b-col class="pt-2 pl-2 pr-0" cols="12" sm="7" md="7">
            <h3
              v-if="this.cardCreatedMessage"
              class="font-weight-bolder text-danger"
            >
              {{ this.cardCreatedMessage }}
              <span class="pl-25">
                <b-icon-exclamation-circle-fill></b-icon-exclamation-circle-fill>
              </span>
            </h3>
            <hr v-if="this.cardCreatedMessage" class="pb-1" />
            <p>
              <span class="font-weight-bolder"> Patient id: </span>
              {{ this.createForm.barcode }}
            </p>
            <hr />
            <h5 class="pt-1">
              <span class="font-weight-bolder"> Patient Name: </span>
              <span v-if="this.patientDetails.first_name">{{
                this.patientDetails.first_name + ' '
              }}</span>
              <span v-if="this.patientDetails.second_name">{{
                this.patientDetails.second_name + ' '
              }}</span>
              <span v-if="this.patientDetails.third_name">{{
                this.patientDetails.third_name + ' '
              }}</span>
              <span v-if="this.patientDetails.forth_name">{{
                this.patientDetails.forth_name
              }}</span>
            </h5>
            <h5 class="pt-1">
              <span class="font-weight-bolder"> Age: </span>
              {{ this.patientDetails.age }}
            </h5>
            <h5 class="pt-1">
              <span class="font-weight-bolder"> Companion Name: </span>
              <span v-if="createForm.first_companion_name"
                >{{ createForm.first_companion_name }}
              </span>
              <span v-if="createForm.second_companion_name"
                >{{ createForm.second_companion_name }}
              </span>
              <span v-if="createForm.third_companion_name"
                >{{ createForm.third_companion_name }}
              </span>
              <span v-if="createForm.forth_companion_name"
                >{{ createForm.forth_companion_name }}
              </span>
            </h5>
          </b-col>
          <b-col class="pt-2 pb-2 qrCol" cols="12" md="5" sm="5">
            <qrcode
              class="qrcodeStyle"
              :size="150"
              :text="this.createForm.barcode"
            ></qrcode>
          </b-col>
        </b-row>
        <br /><br />
        <div style="display: flex; justify-content: center">
          <b-button
            variant="danger"
            @click="
              $router.push({
                name: 'Reception-Departments',
              })
            "
          >
            <b-icon-arrow-left class="mr-1"></b-icon-arrow-left> Go Back to
            Reception
          </b-button>
          <b-button
            style="margin-left: 3rem"
            variant="success"
            @click="generateReport()"
          >
            Print Patient Card
          </b-button>
        </div>
      </div>
    </b-card>
    <b-card v-if="!cardCreatedPage" no-body>
      <div class="m-2">
        <!-- Add modal -->
        <b-row>
          <b-col cols="12" md="12">
            <h2>Create Patient Card</h2>
            <br />
          </b-col>
        </b-row>
        <!-- add Patient's companion name -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
            <h4>Patient's Companion Name</h4>
          </b-col>
          <b-col cols="12" md="12">
            <h2></h2>
          </b-col>
          <b-col md="3">
            <b-form-group label="First Name" label-for="firstName">
              <b-form-input
                v-model="createForm.first_companion_name"
                placeholder=""
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Second Name" label-for="secondName">
              <b-form-input
                v-model="createForm.second_companion_name"
                placeholder=""
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Third Name" label-for="thirdName">
              <b-form-input
                v-model="createForm.third_companion_name"
                placeholder=""
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Forth Name" label-for="forthName">
              <b-form-input
                v-model="createForm.forth_companion_name"
                placeholder=""
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="12">
            <br />
            <h4>Assign Patient to Department</h4>
          </b-col>
          <b-col cols="12" md="12">
            <h2></h2>
          </b-col>
          <b-col md="3">
            <b-form-group label="Department" label-for="Department">
              <v-select
                v-model="selected"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="option"
                placeholder=""
              />
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Add Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col cols="12" md="5">
            <br />
          </b-col>
          <b-col
            cols="5"
            md="4"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <!-- <b-link :to="{ name: 'Reception-Departments' }"> -->
            <b-button variant="primary" @click="createCard()">
              Create Patient Card
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <div>
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        filename="patient card"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="800px"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
      >
        <section slot="pdf-content">
          <div class="modalDiv modalPrint">
            <b-row>
              <b-col cols="6">
                <div>
                  <b-img
                    :src="require('@/assets/images/banner/htc-logo2.jpeg')"
                    class="modify-img2"
                    alt=" "
                  />
                  <b-img
                    :src="require('@/assets/images//banner/moh-logo.png')"
                    class="modify-img2"
                    alt=" "
                  />
                  <b-img
                    :src="require('@/assets/images/banner/htc-logo.png')"
                    class="modify-img2"
                    alt=" "
                  />
                </div>
              </b-col>
              <b-col cols="6">
                <div>
                  <b-img
                    :src="
                      require('@/assets/images/illustration/htc_logo3.jpeg')
                    "
                    style="width: 28rem; height: 8rem"
                    alt=" "
                  />
                </div>
              </b-col>
            </b-row>
            <br />
            <b-row cols="2" style="color: #000">
              <b-col class="pt-2 pl-2 pr-0" cols="12" sm="7" md="7">
                <br />
                <br />
                <table style="border: 1px solid #000; color: #000">
                  <tr style="border: 1px solid #000">
                    <td
                      class="px-1"
                      style="border: 1px solid #000; width: 15rem"
                    >
                      <h3 class="font-weight-bolder">Patient Name:</h3>
                    </td>
                    <td
                      class="px-1"
                      style="border: 1px solid #000; width: 15rem"
                    >
                      <h3 class="font-modify">
                        <span v-if="this.patientDetails.first_name">{{
                          this.patientDetails.first_name + ' '
                        }}</span>
                        <span v-if="this.patientDetails.second_name">{{
                          this.patientDetails.second_name + ' '
                        }}</span>
                        <span v-if="this.patientDetails.third_name">{{
                          this.patientDetails.third_name + ' '
                        }}</span>
                        <!-- <span v-if="this.patientDetails.forth_name">{{ this.patientDetails.forth_name }}</span> -->
                      </h3>
                    </td>
                  </tr>
                  <tr style="border: 1px solid #000">
                    <td class="px-1" style="border: 1px solid #000">
                      <h3 class="font-weight-bolder">Age:</h3>
                    </td>
                    <td class="px-1" style="border: 1px solid #000">
                      <h3>
                        {{ this.patientDetails.age }}
                      </h3>
                    </td>
                  </tr>
                  <tr style="border: 1px solid #000">
                    <td class="px-1" style="border: 1px solid #000">
                      <h3 class="font-weight-bolder">Companion Name:</h3>
                    </td>
                    <td class="px-1" style="border: 1px solid #000">
                      <h3 class="pt-1">
                        <span
                          class="font-modify"
                          v-if="createForm.first_companion_name"
                          >{{ createForm.first_companion_name }}
                        </span>
                        <span
                          class="font-modify"
                          v-if="createForm.second_companion_name"
                          >{{ createForm.second_companion_name }}
                        </span>
                        <span
                          class="font-modify"
                          v-if="createForm.third_companion_name"
                          >{{ createForm.third_companion_name }}
                        </span>
                        <span
                          class="font-modify"
                          v-if="createForm.forth_companion_name"
                          >{{ createForm.forth_companion_name }}
                        </span>
                      </h3>
                    </td>
                  </tr>
                </table>
              </b-col>
              <b-col class="pt-2 pb-2 qrCol" cols="12" md="5" sm="5">
                <qrcode
                  class="qrcodeStyle"
                  :size="150"
                  :text="this.createForm.barcode"
                ></qrcode>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <br />
                <br />
                <br />
                <b-card>
                  <div v-if="Latestdiagnosis">
                    <h2>Latest Diagnosis :</h2>
                    <br />
                    <b-row>
                      <b-col>
                        <div>
                          <h3>- {{ Latestdiagnosis }}</h3>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </section>
      </vue-html2pdf>
    </div>
  </div>

  <!-- Table Container Card -->
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BModal,
  BAlert,
  VBModal,
  BCardText,
  BIcon,
  BIconArrowLeft,
  BIconExclamationCircleFill,
  BImg,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { onUnmounted } from '@vue/composition-api';
import store from '@/store';
import router from '@/router';
import Ripple from 'vue-ripple-directive';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import VueQRCodeComponent from 'vue-qrcode-component';
import VueHtml2pdf from 'vue-html2pdf';
export default {
  components: {
    qrcode: VueQRCodeComponent,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BAlert,
    BCardText,
    BIcon,
    VueHtml2pdf,
    BIconArrowLeft,
    BIconExclamationCircleFill,
    BImg,
  },

  data() {
    return {
      createForm: {
        first_companion_name: '',
        second_companion_name: '',
        third_companion_name: '',
        forth_companion_name: '',
        department_id: '',
        patient_id: '',
        barcode: '',
      },
      patient_id: router.currentRoute.params.id,
      take: 1000,
      cardCreatedMessage: '',
      patientDetails: {},
      loading: true,
      selected: 'Clinic',
      option: [
        'Clinic', // id = 3
        'Emergency', // id = 4
        'Laboratory', // id = 5
        'Pharmacy', // id = 6
        'Daily Care', // id = 7
        'Consultant', // id = 8
        'Hsct', // id = 13
      ],
      params: {
        form: {},
        path: '',
      },
      cardCreatedPage: false,
      Latestdiagnosis: '',
    };
  },
  mounted() {
    this.index();
  },

  methods: {
    async index() {
      await this.getList(
        `/patient?take=${this.take}&filter[id]=${this.patient_id}&sort=-id`
      );
      for (let item in this.all_data.data) {
        if (this.all_data.data[item].id == this.patient_id)
          this.patientDetails = this.all_data.data[item];
        this.getDiagnosis();
      }
      let dt = new Date().getTime();
      this.createForm.barcode = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
          let r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
    },
    async getDiagnosis() {
      await this.getList(
        `/patient/diagnosis?take=5&sort=-id&include=disease_item&patient_id=${this.patientDetails.uuid}`
      );
      if (this.all_data.data[0]) {
        this.Latestdiagnosis = this.all_data.data[0].disease_item.name;
      }
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },

    createCard() {
      log('dsdsdsdsdsdsdssssssssssss');
      this.createForm.department_id = this.option.indexOf(this.selected) + 3;
      if (this.createForm.department_id == 9) {
        this.createForm.department_id += 3;
      }
      this.createForm.patient_id = this.patientDetails.uuid;
      // this.createForm.barcode = this.patientDetails.uuid;
      (this.params.form = this.createForm),
        (this.params.path = '/patient/card');
      if (this.createForm.first_companion_name == '') {
        delete this.params.form.first_companion_name;
      }
      if (this.createForm.second_companion_name == '') {
        delete this.params.form.second_companion_name;
      }
      if (this.createForm.third_companion_name == '') {
        delete this.params.form.third_companion_name;
      }
      if (this.createForm.forth_companion_name == '') {
        delete this.params.form.forth_companion_name;
      }
      this.$store
        .dispatch('create', this.params)
        .then((response) => {
          this.cardCreatedPage = true;
          if (response.status == 208) {
            this.cardCreatedMessage = 'This Card is Already Created Today';
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            for (let item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'validation error',
                  variant: 'danger',
                  text: error.response.data[item][0],
                },
              });
            }
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 576px) {
  .modalDiv {
    height: 34rem;
  }
}

.qrcodeStyle {
  width: 10rem;
  margin: 0 auto;
  padding-top: 2rem;
}

.font-modify {
  letter-spacing: normal !important;
}

.modalPrint {
  margin-top: 1rem;
  margin-left: 3rem;
}
.modify-img {
  height: 8rem;
  width: 10rem;
}
.modify-img2 {
  height: 5rem;
  width: 5rem;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
